// src/components/OrderNotificationModal.js
import React from 'react';

const OrderNotificationModal = ({ order, restaurant, onAcknowledge, onClose }) => {
  if (!order) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeIn 0.3s ease-in'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #FF4444, #FF6B00)',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        color: 'white',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(255, 68, 68, 0.6)',
        position: 'relative',
        animation: 'slideUp 0.4s ease-out, pulse 2s ease-in-out infinite'
      }}>
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'rgba(255,255,255,0.3)',
            border: 'none',
            borderRadius: '50%',
            width: '35px',
            height: '35px',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'background 0.3s ease'
          }}
          onMouseOver={(e) => e.target.style.background = 'rgba(255,255,255,0.5)'}
          onMouseOut={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
        >
          ×
        </button>

        {/* Icon */}
        <div style={{ 
          fontSize: '4rem', 
          marginBottom: '20px',
          animation: 'bounce 1s ease-in-out infinite'
        }}>
          🔔
        </div>

        {/* Title */}
        <h2 style={{
          margin: '0 0 20px 0',
          fontSize: '2.5rem',
          fontWeight: '700',
          textShadow: '0 2px 10px rgba(0,0,0,0.3)',
          letterSpacing: '1px'
        }}>
          NEW ORDER!
        </h2>

        {/* Order Details */}
        <div style={{
          background: 'rgba(255,255,255,0.2)',
          borderRadius: '15px',
          padding: '25px',
          marginBottom: '30px',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{ 
            fontSize: '1.3rem', 
            marginBottom: '10px', 
            fontWeight: '600',
            opacity: '0.9'
          }}>
            Order #{order.order_number}
          </div>
          <div style={{ 
            fontSize: '2rem', 
            fontWeight: '700', 
            marginBottom: '10px' 
          }}>
            {order.restaurant_tables?.custom_name || 
             `Table ${order.restaurant_tables?.table_number || order.table_id}`}
          </div>
          <div style={{ 
            fontSize: '2.5rem', 
            fontWeight: '700',
            textShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}>
            {restaurant?.default_currency || '₹'}{order.total_amount}
          </div>
        </div>

        {/* Items List */}
        {order.order_items && order.order_items.length > 0 && (
          <div style={{
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '12px',
            padding: '15px',
            marginBottom: '25px',
            textAlign: 'left',
            maxHeight: '150px',
            overflowY: 'auto'
          }}>
            {order.order_items.map((item, idx) => (
              <div key={idx} style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '8px',
                fontSize: '1rem',
                padding: '5px 0'
              }}>
                <span style={{ fontWeight: '600' }}>
                  {item.quantity}x {item.menu_items?.name || 'Item'}
                </span>
                <span style={{ fontWeight: '700' }}>
                  {restaurant?.default_currency || '₹'}{item.total_price}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* Acknowledge Button */}
        <button
          onClick={onAcknowledge}
          style={{
            width: '100%',
            background: 'white',
            color: '#FF4444',
            border: 'none',
            borderRadius: '15px',
            padding: '18px',
            fontSize: '1.3rem',
            fontWeight: '700',
            cursor: 'pointer',
            boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
            transition: 'transform 0.2s ease, boxShadow 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 12px 30px rgba(0,0,0,0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.3)';
          }}
        >
          ✓ ACKNOWLEDGE ORDER
        </button>

        <p style={{
          marginTop: '15px',
          fontSize: '0.85rem',
          opacity: '0.8'
        }}>
          Sound will stop once acknowledged
        </p>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from { 
            transform: translateY(50px);
            opacity: 0;
          }
          to { 
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1);
            boxShadow: 0 20px 60px rgba(255, 68, 68, 0.6);
          }
          50% { 
            transform: scale(1.02);
            boxShadow: 0 25px 70px rgba(255, 68, 68, 0.8);
          }
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default OrderNotificationModal;